export const COUNTRIES = {
    UNITED_STATES: 'US',
};
export const DEFAULT_COUNTRY = COUNTRIES.UNITED_STATES;
